<template>
  <v-row class="mt-4" justify="center">
    <v-dialog
      v-model="joinEmailDialog"
      max-width="680px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#0B5940"
          dark
          v-bind="attrs"
          v-on="on"
          class="px-2 py-4 caption signupEmailNotify"
        >
          Sign-up<br/>For Email Notifications
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="pa-0">
          <v-container style="background: #f4f8fa !important;" class="pa-0" >
            <div class="px-6" >
              <iframe
                width="100%"
                :src="embeddedCode"
                title="Join Our Email List"
                style="min-height:560px;!important;border: none !important;"
              >
              </iframe>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#0B5940"
            text
            @click="joinEmailDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'JoinEmailList',
  data: () => ({
    joinEmailDialog: false,
    embeddedCode: 'https://share.hsforms.com/17CQSzmjwQdi9zk-DEDlixg3yz4l'
  })
}
</script>
